import { ViewFoodEvent, ViewPostFoodEvent } from '@xeetr/types/models'

import ApiService from './common/API.service'


export class FoodEventService extends ApiService {
  postFoodEvent = async (data: ViewPostFoodEvent): Promise<ViewFoodEvent> => {
    const { data: response } = await this.post<ViewPostFoodEvent, ViewFoodEvent>(
      this.buildTenantUrl('event'),
      data
    )
    return response
  }

  putFoodEvent = async (data: ViewPostFoodEvent & { id: string }): Promise<ViewFoodEvent> => {
    const { data: response } = await this.put<ViewPostFoodEvent & { id: string }, ViewFoodEvent>(
      this.buildTenantUrl('event'),
      data
    )
    return response
  }

  getFoodEvent = async (id: string): Promise<ViewFoodEvent> => {
    const { data } = await this.get<ViewFoodEvent>(this.buildTenantUrl('event'), {
      params: { id },
    })
    return data
  }

  deleteFoodEvent = async (id: string): Promise<void> => {
    await this.delete(this.buildTenantUrl('event'), {
      params: { id },
    })
  }
}
